var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M0 14h36v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD2A3E",
    d: "M32 5H4a4 4 0 0 0-4 4v5h36V9a4 4 0 0 0-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#436F4D",
    d: "M4 31h28a4 4 0 0 0 4-4v-5H0v5a4 4 0 0 0 4 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/hu.7fc6be78004a711d780b9ce2730f76fc.svg";
export { ForwardRef as ReactComponent };